module.exports = __webpack_public_path__ + "static/media/up-logo.5e69da72.png";